<template>
	<div class="app-faq" name="app_faq" id="app_faq">
		<div class="faq-title">{{ getConstants('EAGLE_LANDING_FAQ_TITLE') }}</div>
		<ul class="faq-content">
			<li class="faq-block" v-for="{ title, text } in appFaq" :key="title">
				<h4 class="faq-block-title">{{ title }}</h4>
				<p class="faq-block-text" v-html="text"></p>
			</li>
		</ul>
	</div>
</template>
<script>
export default {
	props: {
		appFaq: {
			type: Array,
			required: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.app-faq {
	padding-top: 160px;
	.faq-title {
		font-size: 32px;
		text-align: center;
		color: #3f4657;
		font-weight: 500;
	}
	.faq-content {
		max-width: 700px;
		margin: 24px auto 0;
	}
	.faq-block {
		margin-top: 40px;
	}
	.faq-block-title {
		font-size: 16px;
		font-weight: 500;
		color: #1e1e1e;
	}
	.faq-block-text {
		white-space: pre-line;
		margin-top: 8px;
		font-size: 14px;
		line-height: 24px;
		color: #575757;
	}
	>>> a {
		color: #107ffc;
	}
}

@media (max-width: 414px) {
	.app-faq {
		padding-top: 80px;
		.faq-content {
			max-width: 288px;
		}
	}
}
</style>
